import React, { Component } from 'react';
import Typography from 'material-ui/Typography';
import Switch from 'material-ui/Switch';
import OptyDialog from './OptyDialog';
import Icon from 'material-ui/Icon';
import TextField from 'material-ui/TextField';
import withSubscription from './withSubscription';
import { formatNumField } from './format';
import api from './api';

class TokenDisplay extends Component {

  state = {
    tokens: ''
  }

  toggleAuthorization() {
    const { token } = this.props;
    token.setAuthorization(!token.approved)
  }

  mint(tokens) {
    const { token } = this.props;
    token.mint(+tokens);
  }

  render() {
    const { token, network, account } = this.props;
    const messages = {
      'unset': 'By performing this action you will remove authorization for Optionality to transfer this token when needed.',
      'set': 'By performing this action, you authorize Optionality to transfer this token when required.'
    }
    const baseurl = api.config.etherscan[network.network];

    return (
      <div>
        <Typography variant="subheading">
          {token.symbol}: {(token.balance || 0).toFixed(Math.min(token.decimals || 0, 5))}
          &nbsp;
          {token.faucet && <Icon onClick={()=>this.addDialog.run()} style={{ fontSize: 12 }} color="primary">add_circle</Icon>}
          <a target="etherscan" href={baseurl + "/token/" + token.address + "?a=" + account.account }><Icon style={{ fontSize: 12 }} color="primary">launch</Icon></a>
        </Typography>
        <div style={{marginTop:'-10px'}}>
          <Typography variant="body1">Authorized:
          <Switch disabled={token._refreshing} checked={token.approved} onChange={()=>this.confirm.run()} color="primary"/>
          </Typography>
        </div>

        <OptyDialog ref={dialog => {this.confirm = dialog}} title={(token.approved ? "Deauthorize" : "Authorize") + " Optionality"} text={messages[token.approved ? 'unset' : 'set']} onOK={()=>this.toggleAuthorization()}/>

        <OptyDialog ref={dialog=>{this.addDialog = dialog}} title="Add some tokens" onOK={()=>this.mint(this.state.tokens)} onDismiss={()=>this.setState({tokens:''})}>
          <TextField label="How many tokens?" value={this.state.tokens} onChange={(event)=>this.setState({tokens:formatNumField(event.target.value)})}/>
        </OptyDialog>
      </div>
    );
  }
}

export default withSubscription(({ token, auth }) => ({ token: api.token(token.address, auth), network: api.network, account: api.account }))(TokenDisplay)


// WEBPACK FOOTER //
// ./src/TokenDisplay.js